import TrackingElement from '../../elements/tracking/TrackingElement';
import { defineElement } from '@webtides/element-js';
import toTrackableSeriesProduct from '../../elements/tracking/transformer/toTrackableListItemProduct';
import { trackViewItemList } from '../../elements/tracking/events/trackViewItemList';

class SeriesPageTracking extends TrackingElement {
    connected() {
        super.connected();

        if (this.$trackingTarget) {
            let seriesCards = this.$trackingTarget.querySelectorAll('series-card');
            let products = Array.from(seriesCards).map(product =>
                JSON.parse(product.getAttribute('data-tracking-product'))
            );
            trackViewItemList(this.id, this.templateName, this.pageTitle, products, toTrackableSeriesProduct);
        }
    }

    properties() {
        return {
            id: '',
            pageTitle: '',
            templateName: '',
        };
    }

    getTrackingTarget() {
        return document.querySelector('series-page');
    }
}

defineElement('series-page-tracking', SeriesPageTracking);
